/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled from 'styled-components';

const displaySizes = {
  mobile: '375px',
  extraMobile: '540px',
  tablet: '768px',
  smallDesktop: '1024px',
  desktop: '1440px',
  largeDesktop: '1920px',
};

const device = {
  desktop: `(min-width:${displaySizes.desktop})`,
  largeDesktop: `(min-width:${displaySizes.largeDesktop})`,
  smallDesktop: `(min-width:${displaySizes.smallDesktop})`,
  mobile: `(max-width:${displaySizes.mobile})`,
  tablet: `(min-width:${displaySizes.tablet})`,
};

const isLegacy = process.env.IS_LEGACY === 'true';

export const WLTPContainer = styled.div`
  background-color: ${(props) =>
    isLegacy ? props.theme?.sys?.color?.canvas?.default : 'transparent'};
  position: relative;
  bottom: 0px;
  height: fit-content;

  .ca-wltp-items {
    margin: 0 5px 0 0;
  }

  a:focus {
    outline: 5px auto Highlight !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }
  span sup a {
    font-size: 10px !important;
    font-weight: 500;
  }
  @media ${device.tablet} {
    flex-direction: row;
    span sup a {
      font-size: 10px !important;
      font-weight: 500;
    }
  }
`;
